import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@mui/material'
import i18n from '../../../simple-react-i18n'
import EmailIcon from '@mui/icons-material/Email'
import SmartphoneIcon from '@mui/icons-material/Smartphone'
import { getFullDate } from '../../../utils/DateUtil'
import CmsAction from '../../../events/actions/CmsAction'
import moment from 'moment/moment'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { orderBy } from 'lodash'
import { nbPerPageLabelMedium } from '../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../components/datatable/NewTable'
import { darkBlue } from '../../../utils/constants/ColorTheme'
import { getStatusCms, IconStatusCms } from './utils/CmsUtils'

const ERROR = 'ERREUR'
const IN_PROGRESS = 'EN COURS'

const MAIL = 'MAIL'
const SMS = 'SMS'


const CmsLogTable = ({
    jobExecutionId,
}) => {
    const dispatch = useDispatch()

    const [cms, setCms] = useState([])

    const HEADERS = [
        { key: 'typeIcon', value: i18n.jobType },
        'status',
        { key: 'dateSend', value: i18n.date },
        { key: 'recipient', value: i18n.destinataire },
        { key: 'contactCode', value: i18n.fullName },
        { key: 'supplierContactCode', value: i18n.supplierCode },
        { key: 'supplierGroupCode', value: i18n.supplierCodeGroup },
        { key: 'supplier', value: i18n.provider },
    ]

    const {
        contacts,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
    }), shallowEqual)

    useEffect(() => {
        dispatch(CmsAction.fetchCmsSend()).then((r) => {
            const formatExpired = r.map(c => {
                const isExpired = moment().diff(moment(c.dateSend), 'minutes') > 5
                if (getStatusCms(c.status, c.dateSend) === IN_PROGRESS && isExpired) {
                    return {
                        ...c,
                        status: ERROR,
                    }
                }
                return c
            })
            const formatCms = formatExpired?.map(c => {
                return {
                    type: c.recipient.includes('@') ? MAIL : SMS,
                    typeIcon: c.recipient.includes('@') ? <Tooltip title={i18n.email}><EmailIcon/></Tooltip> :
                        <Tooltip title={'SMS'}><SmartphoneIcon/></Tooltip>,
                    ...c,
                    contactCode: contacts.find(co => co.id === c.contactCode)?.name ?? i18n.unknownContact,
                    dateSend: getFullDate(c.dateSend),
                    date: c.dateSend,
                    updateDate: getFullDate(c.updateDate),
                    valueStatus: c.status,
                    status: { value: IconStatusCms(c.status), status: c.status, sortValue: c.status },
                }
            })
            setCms(formatCms)
        })
    }, [])

    const cmsFilter = orderBy(cms.filter(c => c.jobExecutionId === jobExecutionId), 'date', 'desc')

    if (cmsFilter.length === 0) {
        return ''
    }

    return (
        <CardTable
            title={i18n.messagesSent}
            color={darkBlue}
            rows={cmsFilter}
            headers={HEADERS}
            rowsPerPageOptions={nbPerPageLabelMedium}
        />
    )
}

CmsLogTable.propTypes = {
    jobExecutionId: PropTypes.number,
}

export default CmsLogTable